function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { embedProps } from './tools';

/**

RandomizeNodePositions component, sets random positions to all nodes.
Can be used within Sigma component with predefined graph or within graph loader component.

**/
var RandomizeNodePositions =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(RandomizeNodePositions, _React$PureComponent);

  function RandomizeNodePositions(props) {
    var _this;

    _classCallCheck(this, RandomizeNodePositions);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RandomizeNodePositions).call(this, props));

    if (_this.props.sigma) {
      _this.props.sigma.graph.nodes().forEach(function (n) {
        n.x = Math.random();
        n.y = Math.random();
      });
    }

    if (_this.props.sigma) _this.props.sigma.refresh();
    return _this;
  }

  _createClass(RandomizeNodePositions, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.sigma) this.props.sigma.refresh();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", null, embedProps(this.props.children, {
        sigma: this.props.sigma
      }));
    }
  }]);

  return RandomizeNodePositions;
}(React.PureComponent);

_defineProperty(RandomizeNodePositions, "propTypes", {
  children: PropTypes.any,
  sigma: function (_sigma) {
    function sigma() {
      return _sigma.apply(this, arguments);
    }

    sigma.toString = function () {
      return _sigma.toString();
    };

    return sigma;
  }(function () {
    return (typeof sigma === "function" ? PropTypes.instanceOf(sigma) : PropTypes.any).apply(this, arguments);
  })
});

export default RandomizeNodePositions;
import PropTypes from "prop-types";